import { apiClient, handleResp } from './utils'

export default {
  doCheckout(data) {
    return handleResp(apiClient().post('/checkout_care', data))
  }
}
